import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { getDashboardPath } from '../../utils/navigationUtils';
import { LoadingSpinner } from '../LoadingSpinner';

interface ProtectedRouteProps {
    children: React.ReactNode;
    requiredRole?: 'admin' | 'worker' | 'manager';
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
    children,
    requiredRole
}) => {
    const { user, loading } = useAuth();
    const location = useLocation();

    // Check access permissions

    if (loading) {
        // Still loading, showing spinner
        return (
            <div className="min-h-screen flex items-center justify-center">
                <LoadingSpinner size="lg" />
            </div>
        );
    }

    if (!user) {
        // No user, redirecting to login
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (requiredRole && user.role !== requiredRole) {
        // User role mismatch, redirecting to appropriate dashboard
        const redirectPath = getDashboardPath(user.role);
        return <Navigate to={redirectPath} replace />;
    }

    // Access granted
    return <>{children}</>;
};
